<template>
    <DxToolbar>
        <DxItem
            widget="dxButton"
            :options="refreshButton"
            location="before"
        />
        <DxItem
            v-for="(item, index) in toolbarItems"
            :key="index"
            :widget="item.widget"
            :options="action(item.action)"
            :location="item.location"
        />
    </DxToolbar>
</template>

<script>
  /**
   * Importaciones devExtreme
   */
  import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
  import DxButton from 'devextreme-vue/button';

  /**
   * Importaciones Vue
   */
  import { useStore } from 'vuex';

  export default {
      name: 'Toolbar',
      props:{
        option: {
          type: String
        },
        toolbarItems: {
          type: Object
        }
      },
      components: {
          DxToolbar,
          DxItem,
          DxButton
      },
      setup(props, context) {
          const store = useStore();

          /**
           * METHODS
           */
          const action = (action) => {
            if(action === 'export') {
              return exportXls;
            }
            if(action === 'more') {
              return moreButton;
            }
            if(action === 'add') {
              return addButton;
            }
            if(action === 'select'){
              return selectBoxOptions;
            }
          }

          const addButton =  {
            icon: 'plus',
            onClick: () => {
              store.dispatch('changeForm','add');
              context.emit('accionPopup');
            }
          };
          const refreshButton =  {
            icon: 'pulldown',
            onClick: () => {
              context.emit('accionRefresh');
            }
          };
          const moreButton =  {
            icon: 'overflow',
            onClick: () => {
              console.log('more ', props.option);
            }
          };
          const exportXls =  {
            icon: 'xlsfile',
            onClick: () => {
              console.log('export ', props.option);
              context.emit('accionExport');
            }
          };
          
          /* 
          * Items: Debería venir en el JSON
          * Value: Esta Hardcodeado
          * Faltaría definir una función "onValueChanged()"
          */
          const selectBoxOptions = {
            items: [{id:1, text:'All'},{id:2,text:'option1'}],
            valueExpr: 'id',
            displayExpr: 'text',
            value: 1
          }
          
          return {
              addButton,
              refreshButton,
              moreButton,
              exportXls,
              action,
              selectBoxOptions
          }
      }
  }
</script>

<style>

</style>